import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-reduce",
  "use": "map-reduce-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"map-reduce\">\r\n<style type=\"text/css\">\r\n\t#map-reduce .st0{fill:none;stroke:#3A3A3A;stroke-width:3;}\r\n</style>\r\n<path class=\"st0\" d=\"M9.3,9.3l-7-7 M9.3,9.3h-7 M9.3,9.3v-7 M18.7,9.3l7-7 M18.7,9.3h7 M18.7,9.3v-7 M18.7,18.7l7,7 M18.7,18.7v7\r\n\t M18.7,18.7h7 M9.3,18.7l-7,7 M9.3,18.7h-7 M9.3,18.7v7\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol